export enum QualityType {
  Real = 'Real',
  Bot = 'Bot'
}
